"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = exports.parseData = void 0;

var axios_1 = __importDefault(require("axios"));

var techErrorMessage = "Une erreur technique s'est produite. Merci de réessayer ultérieurement ou contacter votre service client.";
var defaultOptions = {
  headers: {
    get: {
      'Content-Type': 'application/json'
    }
  }
};

exports.parseData = function (data) {
  var params = new URLSearchParams();
  Object.keys(data).map(function (key) {
    var value = data[key];
    return params.append(key, value);
  });
  return params.toString();
};

exports.request = function (options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var token = localStorage.getItem('token');
  if (token) options.headers.Authorization = "Bearer " + token;
  var instance = axios_1.default.create(options);
  instance.defaults.transformRequest = [function (data) {
    return data ? exports.parseData(data) : data;
  }];
  instance.interceptors.request.use(function (req) {
    !req.data && delete req.data;
    return req;
  });
  instance.interceptors.response.use(function (res) {
    return res;
  }, function (error) {
    if (error.response.status === 401) {
      var origin_1 = window.location.origin;
      window.location.href = origin_1 + process.env.REACT_APP_IDP_LOGIN_URL;
    }

    if (error.response.status >= 500 || Number(error.response.data.code) >= 10 && Number(error.response.data.code) <= 13) {
      error.response.data.message = techErrorMessage;
    }

    return Promise.reject(error);
  });
  return instance;
};

exports.default = exports.request;